import { Pipe, PipeTransform } from '@angular/core';

import { microsToNumber } from '@app/core/utilities/number.utilities';

@Pipe({ name: 'microsToNumber' })
export class MicrosToNumberPipe implements PipeTransform {
  transform(value: number): number {
    return microsToNumber(value);
  }
}
